import { render, staticRenderFns } from "./UserWalletCard.vue?vue&type=template&id=17d432a6&scoped=true&"
import script from "./UserWalletCard.vue?vue&type=script&lang=js&"
export * from "./UserWalletCard.vue?vue&type=script&lang=js&"
import style0 from "./UserWalletCard.vue?vue&type=style&index=0&id=17d432a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d432a6",
  null
  
)

export default component.exports